import vatRegions from '@/generated/vatRegions.json'

import type { CountryOptions } from './multiRegion/timezonesCitiesAndCountries'

export const taxAcronym = (countryCode?: string) =>
  vatRegions.find((vatRegion) => vatRegion.code === countryCode)?.taxAcronym || 'TAX'

// MenuItem.taxRate is a fraction (0.2 = 20% VAT, 0.1 = 10% GST). Number()
// drops the trailing zeros toFixed leaves on whole rates (20, not 20.00).
export const formatTaxRatePercent = (rate: number) => `${Number((rate * 100).toFixed(2))}%`

export const getRegionsByCountryCode = (
  countryCode: string | undefined | null,
  countryOptions: CountryOptions[],
) => {
  const filteredCountryOptions = countryOptions.find(
    (countryOption) => countryOption.value === countryCode,
  )
  return filteredCountryOptions?.label
}
